module.exports = __webpack_public_path__ + "media/img/private-venue/bridge-ca12d19ee13dcee9093b10d8276bf5e6.png";